import { media, font, color, spacing } from "@universityofmaryland/web-token-library";
import "../../animation/line.js";
import "../../animation/loader.js";
import "../../animation/nested-elements.js";
import { slideRight } from "../../animation/transition.js";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import { eyebrow } from "../../typography/elements.js";
import "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-decoration";
const watermarkChild = {
  position: "absolute",
  top: "20px",
  left: "-2%",
  color: color.gray.lighter,
  fontWeight: "bold",
  textTransform: "uppercase",
  fontSize: `min(calc(${font.size["5xl"]} + 13vw), 240px)`,
  lineHeight: "0",
  pointerEvents: "none",
  userSelect: "none",
  [`@media (${media.queries.large.max})`]: {
    display: "none"
  }
};
function composeWatermark(options) {
  const { theme = "light" } = options || {};
  let composed = {
    position: "relative",
    "> *": {
      ...watermarkChild,
      ...slideRight
    }
  };
  if (theme === "light") {
    composed = {
      ...composed,
      "> *": {
        ...composed["> *"],
        opacity: "0.6",
        zIndex: "-1"
      }
    };
  } else if (theme === "dark") {
    composed = {
      ...composed,
      "> *": {
        ...composed["> *"],
        opacity: "0.12",
        zIndex: "inherit"
      }
    };
  }
  const className = theme === "dark" ? `${classNamePrefix}-watermark-dark` : `${classNamePrefix}-watermark`;
  const deprecatedAliases = theme === "dark" ? ["umd-watermark-dark"] : ["umd-watermark"];
  return objectWithClassName({
    ...composed,
    className: [className, ...deprecatedAliases]
  });
}
const watermark = composeWatermark();
const watermarkDark = composeWatermark({ theme: "dark" });
const ribbon = objectWithClassName({
  className: [
    `${classNamePrefix}-eyebrow`,
    /** @deprecated Use 'umd-text-decoration-eyebrow' instead */
    "umd-eyebrow-ribbon"
  ],
  ...eyebrow,
  backgroundColor: color.gold,
  padding: `${spacing.min} ${spacing.md}`,
  display: `inline-block`,
  clipPath: `polygon(8% 0, 100% 0, 92% 100%, 0 100%)`
});
export {
  composeWatermark,
  ribbon,
  watermark,
  watermarkDark
};
//# sourceMappingURL=decoration.js.map
